// extracted by mini-css-extract-plugin
export default {"container":"Dfkp465i","card":"A0QKGJzw","header":"s891pbu1","title":"J32q7Hg0","label":"gSToUT11","name":"DxRsHMum","buttons":"aGquAs8q","form":"cat23wNP"};